import Decimal from "decimal.js";

export default function toDecimalDisplay(amount, customSeparator = null) {
  const display = Decimal(amount).toFixed(2);
  return customSeparator ? display.replace(".", customSeparator) : display;
}
